import { TextField, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { WA } from '../whatsappTheme';

export default function ChatSearchSignWise({ query, setQuery, compact }) {
  return (
    <TextField
      variant="outlined"
      fullWidth
      size="small"
      placeholder={compact ? 'Search conversations' : 'Search contacts...'}
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      InputProps={{
        style: {
          borderRadius: compact ? 22 : 10,
          backgroundColor: compact ? '#fff' : undefined,
          fontSize: 14,
        },
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon style={{ color: compact ? WA.meta : 'gray', fontSize: 20 }} />
          </InputAdornment>
        ),
      }}
      sx={
        compact
          ? {
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: WA.border },
                '&:hover fieldset': { borderColor: '#C4CDD5' },
                '&.Mui-focused fieldset': { borderColor: WA.header },
              },
            }
          : undefined
      }
    />
  );
}
